import { useCallback, useRef } from 'react';
import { useSelector } from 'react-redux';
import { getIsFeatureSwitchEnabled } from 'state/feature-switches/selectors';
import { timingEvent } from 'libs/common/event-tracker/events';
import useTracking from 'hooks/useTracking/useTracking';

function useAdRenderedCheck() {
  const isAdsLoadTimeLoggingEnabled = useSelector(getIsFeatureSwitchEnabled('web_ads_load_time_logging'));
  const {
    track
  } = useTracking();
  const adRequestTimestampRef = useRef(0);
  const onRequest = useCallback(() => {
    if (!isAdsLoadTimeLoggingEnabled) return;
    adRequestTimestampRef.current = Date.now();
  }, [isAdsLoadTimeLoggingEnabled]);
  const onLoad = useCallback(trackingCode => {
    if (!adRequestTimestampRef.current || !isAdsLoadTimeLoggingEnabled) return;
    const adLoadTime = Date.now() - adRequestTimestampRef.current;
    track(timingEvent({
      section: 'ad_load',
      duration: adLoadTime,
      completionState: 'succeeded',
      data: trackingCode
    }));
  }, [track, isAdsLoadTimeLoggingEnabled]);
  return {
    onRequest,
    onLoad
  };
}

export default useAdRenderedCheck;